import { GET_DATA_HEADER_TABLEREPORT_PLANHANDLE_SUCCEEDED, REQUEST_DATA_HEADER_TABLEREPORT_PLANHANDLE_FAILED, CLEAR_DATA_HEADER_TABLEREPORT_PLANHANDLE} from '../actions/actionTypes'

const headerTableReportReducer = (DataHeaderTableReport = [], actions) => {
    switch (actions.type) {
        case CLEAR_DATA_HEADER_TABLEREPORT_PLANHANDLE:
            return {...DataHeaderTableReport,DataHeaderTableReport: []}
        case GET_DATA_HEADER_TABLEREPORT_PLANHANDLE_SUCCEEDED:
            if(Object.keys(actions.DataHeaderTableReport).length > 0)
            {
                return {...DataHeaderTableReport, DataHeaderTableReport: actions.DataHeaderTableReport};
            }
            else
            {
                return {...DataHeaderTableReport};
            }
        case REQUEST_DATA_HEADER_TABLEREPORT_PLANHANDLE_FAILED:
            return {...DataHeaderTableReport,DataHeaderTableReport: []};
        default:
            return {...DataHeaderTableReport};
    }
}

export default headerTableReportReducer;